export const kPa = 'kPa'
export const PSI = 'PSI'
